import { AppError } from "./AppError";

//

export class HttpError extends AppError<Record<string, unknown>> {
  constructor(message: string, data?: Record<string, unknown>) {
    super(message, { data });
    this.name = "HttpError";
    Error.captureStackTrace(this, HttpError);
  }
}
